import axios from "axios";
export default {
	data() {
		return {
			regimeOptions: [],
			regimiPathResource: "/accettazioneregimi",
		};
	},
	methods: {
		regimiLoadData(afterLoad = null) {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.regimiPathResource;
			axios.get(link)
				.then((response) => {
					me.regimeOptions = response.data.data.list;
					me.regimeOptions.unshift({ codice: null, descrizione: "- Regime -" });
					if (afterLoad != null) {
						afterLoad();
					}
				})
				.catch((error) => {
					console.log("Il servizio dei regimi ha datao errore: " + error.response.status);
				});
		},
	},
};
